import { genderPair, localeFunction } from './locale';

import Data from './index';
import * as LogicLive from './logic';
//import * as LogicPTR from './logic_ptr';

import { addActive } from './actives';
import { deepCopy, clone } from 'utils';
import { getAssetsPath, getStoredValue, PTR } from 'common';

//Object.assign(Data, PTR ? LogicPTR : LogicLive);
Object.assign(Data, LogicLive);

function fixkeys(obj, table) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    result[table[key] || key] = value;
  }
  return result;
}

function statFormat(stat) {
  if (stat.format) return stat.format;
  const args = [...Array(stat.args == null ? 1 : stat.args)].map(() => "%d");
  return `+${args.join("-")} ${stat.name}`;
}

class NamedRegExp {
  constructor(re, list) {
    this.re = re;
    this.list = list;
  }
  exec(text) {
    const res = this.re.exec(text);
    if (!res) return null;
    const ans = [res[0]];
    for (let i = 0; i < this.list.length; ++i) {
      if (this.list[i] === undefined) {
        ans.push(res[i]);
      } else {
        ans[this.list[i] + 1] = res[i];
      }
    }
    return ans;
  }
}

function statRegex(classes, stat, format, cls) {
  format = (format || statFormat(stat));
  const list = [];
  let any = false, passive = false;
  format = format.replace(/%(?:\{([0-9]+)\})?(d|\.[0-9]f|p)/g, (m, idx, arg) => {
    list.push(idx ? parseInt(idx) : undefined);
    if (idx) any = true;
    if (arg === "p") passive = true;
    return (arg === "p" ? "#" : "@");
  });
  format = format.replace(/%%/g, "%");
  format = format.replace(/[$-.]|[[-^]|[?|{}]/g, "\\$&");
  format = format.replace(/@/g, "([0-9,]+(?:\\.[0-9]+)?)");
  format = format.replace(/#/g, "(.+)");
  if (stat.class || cls) {
    format += `(?: \\(${classes[stat.class || cls].name} Only\\))?`;
  } else if (passive) {
    format += `(?: \\(.* Only\\))?`;
  }
  const re = new RegExp("^" + format + "$", "i");
  return (any ? new NamedRegExp(re, list) : re);
}

function processData(Data, rawData, locale) {
  rawData = {...rawData};
  rawData.altar = {
    ...rawData.altar,
    minor9: rawData.altar.minor15,
    minor10: rawData.altar.minor16,
    minor11: rawData.altar.minor17,
    minor12: rawData.altar.minor9,
    minor13: rawData.altar.minor10,
    minor14: rawData.altar.minor11,
    minor15: rawData.altar.minor12,
    minor16: rawData.altar.minor13,
    minor17: rawData.altar.minor14,
    minor18: rawData.altar.minor24,
    minor19: rawData.altar.minor25,
    minor20: rawData.altar.minor26,
    minor21: rawData.altar.minor18,
    minor22: rawData.altar.minor19,
    minor23: rawData.altar.minor20,
    minor24: rawData.altar.minor21,
    minor25: rawData.altar.minor22,
    minor26: rawData.altar.minor23,
  };
  deepCopy(Data, rawData);

  const {
    classes,
    items,
    itemSets,
    itemTypes,
    itemSlots,
    metaSlots,
    qualities,
    skills,
    passives,
    followerSkills,
    gemColors,
    gemQualities,
    legendaryGems,
    stats,
    statList,
    statLimits,
    itemaffixes
  } = Data;

  if (locale.localeTableEx) {
    deepCopy(locale.localeTable, locale.localeTableEx);
  }
  const _L = localeFunction(locale.localeTable);
  Data.localeTable = {...locale.localeTable};
  Data.localeTable.statList = {...Data.localeTable.statList};
  delete Data.localeTable.statList.simdps;

  const itemById = Data.itemById = {};

  for (const item of items) {
    itemById[item.id] = item;
  }

  for (const stat in statLimits.legendary) {
    if (!statLimits.ancient.hasOwnProperty(stat)) {
      statLimits.ancient[stat] = statLimits.legendary[stat];
    }
    if (!statLimits.rare.hasOwnProperty(stat)) {
      statLimits.rare[stat] = statLimits.legendary[stat];
    }
  }
  statLimits.primal = Object.assign({}, statLimits.ancient);

  for (const item of Data.potions) {
    item.defaultName = item.name;
    Object.defineProperty(itemById, item.id, {
      value: item,
      enumerable: false,
    });
  }
  for (const item of Data.extraItems) {
    item.defaultName = item.name;
    Object.defineProperty(itemById, item.id, {
      value: item,
      enumerable: false,
    });
  }

  statList.primary = fixkeys(statList.primary, locale.localeTable);
  statList.secondary = fixkeys(statList.secondary, locale.localeTable);

  for (const cls in classes) {
    classes[cls].defaultName = classes[cls].name;
  }

  for (const cls in skills) {
    if (!classes[cls]) continue;
    for (const id in skills[cls]) {
      const skill = skills[cls][id].name;
      skills[cls][id].defaultName = skill;
      skills[cls][id].defaultRunes = {...skills[cls][id].runes};
      stats[`skill_${cls}_${id}`] = {
        name: `${skill} Damage`,
        format: `Increases ${skill} Damage by %d%%`,
        class: cls,
        skill: skill,
      };
    }
  }
  for (const cls in passives) {
    for (const id in passives[cls]) {
      passives[cls][id].defaultName = passives[cls][id].name;
    }
  }

  for (const skill of Object.values(followerSkills)) {
    skill.defaultName = skill.name;
  }

  for (const id in stats) {
    const stat = stats[id];
    if (stat.base) continue;
    stat.regex = statRegex(classes, stat);
  }
  for (const item of items) {
    item.defaultName = item.name;
    if (item.required && item.required.custom && item.required.custom.format) {
      const lines = item.required.custom.format.split('\r\n');
      item.required.custom.regex = statRegex(classes, item.required.custom, lines.map(line => line.trim()).join('\n'), Data.itemPowerClasses[item.required.custom.id]);
      if (lines.length > 1) {
        item.required.custom.lines = lines.length;
        item.required.custom.regexFull = item.required.custom.regex;
        item.required.custom.regex = statRegex(classes, item.required.custom, lines[0], Data.itemPowerClasses[item.required.custom.id])
      }
      if (item.required.custom.altformat) {
        item.required.custom.altregex = statRegex(classes, item.required.custom, item.required.custom.altformat, Data.itemPowerClasses[item.required.custom.id]);
      }
    }
    if (item.legacy) {
      item.suffix = _L`Legacy`;
    } else if (item.retro) {
      item.suffix = _L`Retro`;
    } else if (item.rank != null) {
      item.suffix = _L`Rank ${item.rank}`;
    }
  }
  for (const id in itemSets) {
    itemSets[id].defaultName = itemSets[id].name;
  }

  for (const gem of Object.values(gemColors)) {
    gem.defaultNames = [gem.name];
    for (const q of gemQualities.slice(1)) {
      gem.defaultNames.push(q + " " + gem.name);
    }
  }
  for (const gem of Object.values(legendaryGems)) {
    gem.defaultName = gem.name;
  }

  deepCopy(Data, locale.patch);
  for (const id of Object.getOwnPropertyNames(itemById)) {
    if (!itemById[id].id) {
      delete itemById[id];
    }
  }
  for (const id of Object.getOwnPropertyNames(legendaryGems)) {
    if (!legendaryGems[id].id) {
      delete legendaryGems[id];
    }
  }

  for (const cls in skills) {
    if (!classes[cls]) continue;
    for (const id in skills[cls]) {
      const skill = skills[cls][id].name;
      const stat = stats[`skill_${cls}_${id}`];
      stat.name = _L`${skill} Damage`;
      stat.format = _L`Increases ${skill} Damage by %d%%`;
      stat.skill = skill;
    }
  }

  const sourceNames = Data.sourceNames = {gems: _L`Gems`, paragon: _L`Paragon`, dualwield: _L`Dual Wielding`, seasonal: _L`Seasonal Buff`};

  let statId = 0;
  for (const id in stats) {
    sourceNames[id] = stats[id].name;
  }
  for (const stat of Object.values(stats)) {
    if (!stat.skill) {
      statId += 10;
      stat.prio = statId;
    }
    if (stat.class) {
      stat.classes = [stat.class];
    }
    if (stat.args == null) {
      stat.args = 1;
    }
    if (!stat.format) {
      stat.format = statFormat(stat);
    }
  }
  for (const stat of Object.values(stats)) {
    if (stat.skill) {
      stat.prio = stats.skill_wizard_teleport_cooldown.prio - 5;
    }
  }

  for (const group of Data.statExclusiveGroups) {
    for (const stat of Data.extendStats([], group)) {
      stats[stat].group = group;
    }
  }

  for (const [id, slot] of Object.entries(itemSlots)) {
    slot.types = {};
    sourceNames[id] = slot.name;
  }
  for (const [id, type] of Object.entries(itemTypes)) {
    if (metaSlots[type.slot]) {
      for (const slot of metaSlots[type.slot].slots) {
        itemSlots[slot].types[id] = type;
      }
    } else if (type.slot) {
      itemSlots[type.slot].types[id] = type;
    }
    if (type.class) {
      type.classes = [type.class];
    }
    type.items = [];
  }

  for (const [id, set] of Object.entries(itemSets)) {
    set.items = [];
    sourceNames[id] = set.name;
  }
  items.sort((a, b) => {
    if (a.quality !== b.quality) return a.quality.localeCompare(b.quality);
    const an = a.name.toLowerCase().replace(/^(?:the|a) /, "");
    const bn = b.name.toLowerCase().replace(/^(?:the|a) /, "");
    return an.localeCompare(bn);
  });

  for (const item of items) {
    if (item.ids) for (const id of item.ids) {
      itemById[id] = item;
    }
    itemTypes[item.type].items.push(item);
    sourceNames[item.id] = item.name;
    if (item.set) {
      const set = itemSets[item.set];
      set.items.push(item);
      if (set.class) {
        item.class = set.class;
      }
      if (set.classes) {
        item.classes = set.classes;
      }
    }
    if (item.class) {
      item.classes = [item.class];
    }
    if (item.required && item.required.custom?.id) {
      item.required.custom.nostack = true;
    }
  }

  for (const set of Object.values(itemSets)) {
    if (set.order) {
      set.items.sort(function(a, b) {
        return set.order.indexOf(a.type) - set.order.indexOf(b.type);
      });
    }
  }

  for (const [id, type] of Object.entries(itemTypes)) {
    if (!type.generic) continue;
    const item = {
      id: type.generic,
      name: genderPair(qualities.rare.prefix, type.name),
      type: id,
      quality: "rare",
    };
    items.push(item);
    itemById[item.id] = item;
    itemTypes[id].items.unshift(item);
  }

  const gemById = Data.gemById = {};
  for (const [type, gem] of Object.entries(gemColors)) {
    if (!gem.names) {
      gem.names = [gem.name];
      for (const q of gemQualities.slice(1)) {
        gem.names.push(q + " " + gem.name);
      }
    }
    for (let i = 0; i < gemQualities.length; ++i) {
      gemById[gem.id + (i + 1).toString().padStart(2, "0")] = [i, type];
    }
    for (let i = 0; i < Data.oldGemQualities.length; ++i) {
      gemById[gem.oldid + (i + 1).toString().padStart(2, "0")] = [Data.oldGemQualities[i], type];
    }
  }

  for (const [type, gem] of Object.entries(legendaryGems)) {
    gemById[gem.id] = [type, 0];
    sourceNames[type] = gem.name;
    if (gem.ids) for (const id of gem.ids) {
      gemById[id] = [type, 0];
    }
    for (const effect of gem.effects) {
      effect.args = (effect.value || []).length;
    }
  }

  const skillById = Data.skillById = {};
  for (const cls in skills) {
    const dst = skillById[cls] = {};
    for (const id in skills[cls]) {
      dst[skills[cls][id].id] = id;
    }
    for (const id in passives[cls]) {
      dst[passives[cls][id].id] = id;
    }
  }

  for (const [id, gem] of Object.entries(legendaryGems)) {
    addActive("global", id, gem);
  }
  for (const [id, affix] of Object.entries(itemaffixes)) {
    if (affix.clone) {
      itemaffixes[id] = clone(itemaffixes[affix.clone]);
    } else {
      addActive("global", id, affix);
    }
    itemaffixes[id].affixid = id;
  }

  const allSkills = Data.allSkills = {};
  for (const cls in skills) {
    for (const id in skills[cls]) {
      const skill = skills[cls][id];
      allSkills[id] = [cls, skill];
      sourceNames[id] = skill.name;
      addActive("global", id, skill);
    }
  }

  const allPassives = Data.allPassives = {};
  for (const cls in passives) {
    for (const id in passives[cls]) {
      const passive = passives[cls][id];
      allPassives[id] = [cls, passive];
      sourceNames[id] = passive.name;
      addActive("global", id, passive);
    }
  }

  for (const id in followerSkills) {
    const skill = followerSkills[id];
    sourceNames[id] = skill.name;
    addActive("global", id, skill);
  }

  function addStats(dst, src) {
    for (const x in src) {
      if (typeof src[x] === "object") {
        dst[x] = src[x];
      } else if (stats[x] && stats[x].dr) {
        dst[x] = 100 * (1 - (1 - 0.01 * (dst[x] || 0)) * (1 - 0.01 * (src[x])));
      } else {
        dst[x] = (dst[x] || 0) + src[x];
      }
    }
  }

  const _L_skills = localeFunction(locale.localeTable, "ui-skills.js");
  const NoRune = _L_skills`No Rune`;
  const partybuffs = Data.partybuffs;
  for (const cls in classes) {
    if (!partybuffs[cls]) continue;

    for (const [id, info] of Object.entries(partybuffs[cls])) {
      const src = (skills[cls][id] || passives[cls][id]);
      if (!info.addpassive) {
        info.active = false;
      }
      info.charClass = cls;
      info.id = id;

      if (info.runelist) {
        info.type = "skill";
        if (info.runelist === "*") {
          info.runes = Object.assign({x: NoRune}, src.runes);
        } else {
          info.runes = {};
          for (const rune of info.runelist) {
            info.runes[rune] = (rune === "x" ? NoRune : src.runes[rune]);
          }
        }

        if (!info.buffs || typeof info.buffs !== "function") {
          let buffs = (info.buffs || src.buffs);
          let passive = (info.passive || src.passive);
          let activebox = 0;
          let passivebox = -1;
          if (buffs && passive) {
            if (info.addpassive) {
              info.boxnames = ["Passive", "Active"];
              activebox = 1;
              passivebox = 0;
            } else {
              info.boxnames = ["Activated"];
            }
          } else {
            passive = (buffs || passive);
            buffs = undefined;
          }
          let passiveFunc = (typeof passive === "object" ? rune => passive[rune] : passive);
          let buffsFunc = (typeof buffs === "object" ? rune => buffs[rune] : buffs);

          info.buffs = function(stats) {
            const res = {};
            if (this.multiple) {
              for (const rune in this.runes) {
                if (this.runevals[rune]) {
                  const boxvals = this.boxvals;
                  if (passivebox < 0 || !boxvals || boxvals[passivebox]) {
                    addStats(res, passiveFunc.call(this, rune, stats));
                  }
                  if (buffs && boxvals && boxvals[activebox]) {
                    addStats(res, buffsFunc.call(this, rune, stats));
                  }
                }
              }
            } else {
              const rune = (this.runevals || this.runelist);
              const boxvals = this.boxvals;
              if (passivebox < 0 || !boxvals || boxvals[passivebox]) {
                addStats(res, passiveFunc.call(this, rune, stats));
              }
              if (buffs && boxvals && boxvals[activebox]) {
                addStats(res, buffsFunc.call(this, rune, stats));
              }
            }
            return res;
          };
        } else if (!info.multiple) {
          const buffs = info.buffs;
          info.buffs = function(stats) {
            const rune = (this.runevals || this.runelist);
            return buffs.call(this, rune, stats);
          };
        }
      } else {
        info.type = "passive";
        if (!info.buffs || typeof info.buffs !== "function") {
          const buffs = (info.buffs || src.buffs);
          if (typeof buffs === "function") {
            info.buffs = buffs;
          } else {
            info.buffs = () => buffs;
          }
        }
      }
    }
  }

  const itemFromAffix = Data.itemFromAffix = {};
  for (const [id, item] of Object.entries(itemById)) {
    if (item.required && item.required.custom?.id) {
      const custom = item.required.custom;
      itemFromAffix[custom.id] = item;
      if (partybuffs.items[custom.id]) {
        partybuffs.items[custom.id].item = id;
        if (custom.args !== 0) {
          partybuffs.items[custom.id].params = [
            {min: custom.min, max: custom.max, name: "Amount"},
          ];
        }
      }
    }
  }

  const orig = partybuffs.items;
  partybuffs.items = {};
  for (const [id, info] of Object.entries(orig)) {
    info.active = false;
    info.id = id;
    if (legendaryGems[id]) {
      info.type = "gem";
      partybuffs.items[id] = info;
      //addActive("party", `buff_${id}`, info);
    } else if (info.item) {
      info.type = "affix";
      if (info.stat) {
        info.buffs = function() {
          return {[this.stat]: this.params[0].val};
        };
      } else if (!info.buffs) {
        if (typeof itemaffixes[id].buffs === "function") {
          info.buffs = itemaffixes[id].buffs;
        } else {
          info.buffs = () => itemaffixes[id].buffs;
        }
      }
      partybuffs.items[info.item] = info;
    }
  }

  Data.partybuffs = [];
  for (const index of [0, 1, 2]) {
    const bufflist = {};
    Data.partybuffs.push(bufflist);
    bufflist.selectClass = state => state.profiles[state.activeProfile].active[`buff${index}`];
    bufflist.setClass = (dispatch, value) => dispatch.profile.setActive(`buff${index}`, value);
    for (const cls in partybuffs) {
      if (cls === "items" || classes[cls]) {
        bufflist[cls] = clone(partybuffs[cls], true);
        for (const [id, info] of Object.entries(bufflist[cls])) {
          addActive("party", `buff${index}_${id}`, info);
        }
      }
    }
  }

  Data.followerbuffs = partybuffs.followers;
  for (const [id, info] of Object.entries(Data.followerbuffs)) {
    info.active = false;
    info.type = "follower";
    sourceNames[id] = info.name;
    addActive("party", id, info);
  }

  Data.shrinebuffs = partybuffs.shrines;
  for (const [id, info] of Object.entries(Data.shrinebuffs)) {
    info.active = false;
    info.type = "shrine";
    sourceNames[id] = info.name;
    addActive("party", id, info);
  }

  Data.statInfo = Object.assign({}, stats);

  Data.addOption("moreWarnings", false);
  Data.addOption("limitStats", true);
  Data.addOption("hideCrossClass", true);
  Data.addOption("hideLegacy", true);
  Data.addOption("showElites", false);
  Data.addOption("targetBoss", false);
  Data.addOption("targetType", "");

  Data._bnet_locale = localeFunction(locale.localeTable, "bnet-tooltips.js");
}

let language = 'enUS';
if (window.pll_current_language && !window.location.pathname.includes('d3planner')) {
  language = (window.pll_current_language === 'de' ? 'deDE' : 'enUS');
} else {
  language = getStoredValue('locale', 'enUS');
}

const loadData = fetch(getAssetsPath(PTR ? 'data_ptr.json' : 'data.json')).then(response => response.json());
const loadLocale = fetch(getAssetsPath(`locale/${language}.json`)).then(response => response.json());

export default Promise.all([loadData, loadLocale]).then(([rawData, rawLocale]) => {
  processData(Data, rawData, rawLocale);
  Data.loaded = true;
});
